//全局变量

export default {
  // 请求成功返回码
  SucessRequstCode:0,
  // 强制下线
  TokenInvalidFlag : 0,
  // 长时间未操作
  LongTimeNotDoFlag : 0
}



// WEBPACK FOOTER //
// ./src/common/global.js